import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { CardLinkOfferLocationDetail, CompanyOfferModel } from '@fgb/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'fgbcl-card-link-offer-locations-map',
  templateUrl: './card-link-offer-locations-map.component.html',
  styleUrls: ['./card-link-offer-locations-map.component.scss'],
})
export class CardLinkOfferLocationsMapComponent implements OnInit, AfterViewInit {
  //Inputs
  @Input() offers: CompanyOfferModel[];
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() cardLinkOfferLocationDetails: CardLinkOfferLocationDetail[];
  uniqeLocation: CardLinkOfferLocationDetail[];

  //Outputs
  @Output() selectedDepartmentID = new EventEmitter<number | undefined>();

  // view child
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
  @ViewChildren(MapMarker) mapMarkersEl: QueryList<MapMarker>;

  mapOptions: google.maps.MapOptions;
  mapCenter: any;
  mapZoom: any;
  mapHeight: string;
  customMarkers: any;
  mapInfo: any = {};

  @ViewChild('search')
  public searchElementRef!: ElementRef;
  @ViewChild(GoogleMap)
  public map!: GoogleMap;
  center!: google.maps.LatLngLiteral;
  constructor(private deviceDetectorService: DeviceDetectorService) {}

  ngOnInit(): void {
    this.uniqeLocation = [...new Map(this.cardLinkOfferLocationDetails.map((item) => [item['City'], item])).values()];
    this.prepareMap();
  }

  onChange(locationCordinates: string) {
    let condinates = locationCordinates.split(':');
    if (condinates.length == 1) {
      this.mapZoom = 6;
      this.mapOptions = {
        center: new google.maps.LatLng(this.latitude, this.longitude),
      }; 
      this.mapCenter = {
        lat: this.latitude,
        lng: this.longitude,
      };
    } else {
      const latLng = new google.maps.LatLng(+condinates[0], +condinates[1]);
      this.mapOptions = {
        center: latLng,
      };
      this.mapCenter = latLng;
      this.mapZoom = 11;
    }
  }

  setValue(location: CardLinkOfferLocationDetail) {
    return String(location.Latitude) + ':' + String(location.Longitude);
  }

  ngAfterViewInit(): void {
    // Align search box to center
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.searchElementRef.nativeElement);
  }
  /** Centers the map on browser's location, sets map options and creates markers */
  private prepareMap(): void {
    navigator.geolocation.getCurrentPosition((position) => {
      this.mapCenter = {
        lat: this.latitude,
        lng: this.longitude,
      };
    });

    this.mapZoom = 6;
    this.mapHeight = this.deviceDetectorService.isMobile() ? '460px' : '670px';
    this.mapOptions = {
      mapTypeId: 'roadmap',
      zoomControl: true,
      scrollwheel: true,
      disableDoubleClickZoom: true,
      center: new google.maps.LatLng(this.latitude, this.longitude),
    };

    this.updateMarkers();
  }

  /** Updates the markers shown on the map from the offers list
   * @param offer company offers to make the markers from
   */
  updateMarkers(): void {
    this.customMarkers = [];
    this.cardLinkOfferLocationDetails.forEach((element) => {
      this.customMarkers.push({
        position: {
          lat: element.Latitude,
          lng: element.Longitude,
        },
        title: element.City,
        address: element.Address,
        options: { animation: google.maps.Animation.DROP },
      });
    });
  }

  /** Opens the info window from a specific marker
   * @param marker google maps marker to be used as anchor for the info window
   * @param departmentID department ID to get the info data from
   * @param emitSelection (optional) emit the selected department ID, to highlight the corresponding offers from the list
   */

  showMarkerDetails(marker: MapMarker, markerdetail: any, emitSelection?: boolean): void {
    this.mapInfo.title = markerdetail?.title;
    this.mapInfo.address = markerdetail?.address;
    this.openInfoWindow(marker);
  }

  /** Opens the info window corresponding to the selected marker
   * @param offer offer from which we want to display the marker's data
   */
  selectMarker(offer: CompanyOfferModel): void {
    this.closeInfoWindow();
    const marker = this.findMapMarker(offer.DepartmentId);
    if (marker) {
      //  this.showMarkerDetails(marker, offer.DepartmentId);
    }
  }

  /** Opens the info window
   * @param marker google maps marker to be used as anchor for the info window
   */
  private openInfoWindow(marker: MapMarker): void {
    this.infoWindow.open(marker);
  }

  /** Closes the info window and resets the department selection */
  private closeInfoWindow(): void {
    this.infoWindow.close();
  }

  /** Looks for the map marker within the google map pins
   * @param departmentId ID of the department that should be found within the markers
   * @returns the google map pin used as anchor to display the info window
   */
  private findMapMarker(departmentId: number) {
    const markersList: any[] = this.mapMarkersEl.toArray();
    const selectedCustomMarker = this.customMarkers.find((m: any) => m.departmentID === departmentId);
    if (selectedCustomMarker) {
      return markersList.find((m) => m.marker.title == selectedCustomMarker.title);
    } else {
      return undefined;
    }
  }
}
